import {
    animate,
    state,
    style,
    transition,
    trigger,
    keyframes,
    AnimationTriggerMetadata, query, animateChild,
} from '@angular/animations';
import {AnimationCurves, AnimationDurations} from '@angular/material/core';

const SORT_ANIMATION_TRANSITION = AnimationDurations.ENTERING + ' ' +
    AnimationCurves.STANDARD_CURVE;

/**
 * Анимации, используемые CustomSort.
 */
export const customSortAnimations: {
    readonly indicator: AnimationTriggerMetadata;
    readonly leftPointer: AnimationTriggerMetadata;
    readonly rightPointer: AnimationTriggerMetadata;
    readonly arrowOpacity: AnimationTriggerMetadata;
    readonly arrowPosition: AnimationTriggerMetadata;
    readonly allowChildren: AnimationTriggerMetadata;
} = {
    /** Анимация, которая перемещает индикатор сортировки. */
    indicator: trigger('indicator', [
        state('active-asc, asc', style({transform: 'translateY(0px)'})),
        // 10px высота индикатора сортировки, минус ширина указателей
        state('active-desc, desc', style({transform: 'translateY(10px)'})),
        transition('active-asc <=> active-desc', animate(SORT_ANIMATION_TRANSITION))
    ]),

    /** Анимация, которая поворачивает левый указатель индикатора в зависимости от направления сортировки. */
    leftPointer: trigger('leftPointer', [
        state('active-asc, asc', style({transform: 'rotate(-45deg)'})),
        state('active-desc, desc', style({transform: 'rotate(45deg)'})),
        transition('active-asc <=> active-desc', animate(SORT_ANIMATION_TRANSITION))
    ]),

    /** Анимация, которая поворачивает правый указатель индикатора в зависимости от направления сортировки. */
    rightPointer: trigger('rightPointer', [
        state('active-asc, asc', style({transform: 'rotate(45deg)'})),
        state('active-desc, desc', style({transform: 'rotate(-45deg)'})),
        transition('active-asc <=> active-desc', animate(SORT_ANIMATION_TRANSITION))
    ]),

    /** Анимация, которая контролирует непрозрачность стрелки. */
    arrowOpacity: trigger('arrowOpacity', [
        state('desc-to-active, asc-to-active, active', style({opacity: 1})),
        state('desc-to-hint, asc-to-hint, hint', style({opacity: .54})),
        state('hint-to-desc, active-to-desc, desc, hint-to-asc, active-to-asc, asc, void',
            style({opacity: 0})),
        // Переход между всеми состояниями, за исключением немедленных переходов
        transition('* => asc, * => desc, * => active, * => hint, * => void', animate('0ms')),
        transition('* <=> *', animate(SORT_ANIMATION_TRANSITION)),
    ]),

    /**
     * Анимация для перевода стрелки в целом. Статусы разделены на две части
     * группы: с анимацией и другие, которые являются непосредственными. Непосредственные состояния: asc, desc,
     * hint и active. Другие состояния определяют конкретную анимацию (от источника к месту назначения)
     * и определяется какая функция их предыдущего воспринимаемого пользователем состояния и следующего состояния
     * будет.
     */
    arrowPosition: trigger('arrowPosition', [
        // Hidden Above => Hint Center
        transition('* => desc-to-hint, * => desc-to-active',
            animate(SORT_ANIMATION_TRANSITION, keyframes([
                style({transform: 'translateY(-25%)'}),
                style({transform: 'translateY(0)'})
            ]))),
        // Hint Center => Hidden Below
        transition('* => hint-to-desc, * => active-to-desc',
            animate(SORT_ANIMATION_TRANSITION, keyframes([
                style({transform: 'translateY(0)'}),
                style({transform: 'translateY(25%)'})
            ]))),
        // Hidden Below => Hint Center
        transition('* => asc-to-hint, * => asc-to-active',
            animate(SORT_ANIMATION_TRANSITION, keyframes([
                style({transform: 'translateY(25%)'}),
                style({transform: 'translateY(0)'})
            ]))),
        // Hint Center => Hidden Above
        transition('* => hint-to-asc, * => active-to-asc',
            animate(SORT_ANIMATION_TRANSITION, keyframes([
                style({transform: 'translateY(0)'}),
                style({transform: 'translateY(-25%)'})
            ]))),
        state('desc-to-hint, asc-to-hint, hint, desc-to-active, asc-to-active, active',
            style({transform: 'translateY(0)'})),
        state('hint-to-desc, active-to-desc, desc',
            style({transform: 'translateY(-25%)'})),
        state('hint-to-asc, active-to-asc, asc',
            style({transform: 'translateY(25%)'})),
    ]),

    /** Необходимый триггер, который вызывает анимацию для дочерних анимаций. */
    allowChildren: trigger('allowChildren', [
        transition('* <=> *', [
            query('@*', animateChild(), {optional: true})
        ])
    ]),
};
